import { useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import { Table } from 'antd';
import { useReportByClient } from '@/app/time-tracking/_shared/hooks';
import { PaginationControls } from '@/components/data-table/PaginationControls';
import ExpandedEntries from './ExpandedEntries';
import { getClientColumns } from './ReportColumns';

export default function ReportByClient({
  filters,
  offset = 1,
  limit = 10,
  onPaginationChange,
  searchParams,
  updateParams,
}) {
  const { t } = useTranslation('forms');
  const { data: response, isLoading } = useReportByClient(filters);
  const rows = response?.data || [];
  const total = response?.total || 0;

  const columns = useMemo(
    () => getClientColumns({ searchParams, updateParams, t }),
    [searchParams, updateParams, t]
  );

  return (
    <Table
      columns={columns}
      dataSource={rows}
      rowKey={(r) => r.client?._id || 'no-client'}
      loading={isLoading}
      className="ant-table-content"
      pagination={
        total > limit
          ? {
              current: offset,
              pageSize: limit,
              total,
              onChange: onPaginationChange,
              showSizeChanger: false,
              showQuickJumper: false,
              position: ['bottomCenter'],
              itemRender: (page, type, originalElement) => (
                <PaginationControls
                  type={type}
                  originalElement={originalElement}
                />
              ),
            }
          : false
      }
      expandable={{
        expandedRowRender: (record) => (
          <ExpandedEntries
            filters={filters}
            groupBy="client"
            groupId={record.client?._id}
            isAdmin
            showProject
            showEmployee
          />
        ),
      }}
    />
  );
}
